
export const maps = {
    virtualOfficeMaps: [
        {
            url: "https://preset-world-21696.map-storage.workadventu.re/great-place-to-work.wam",
            image: "/images/maps/great-place-to-work.png",
            name: "Great Place to Work",
            tags: [
                "workshops",
                "hackathon",
                "job_fairs",
                "trade_fairs",
                "other_event",
                "work",
                "chill",
                "collaborate",
                "event",
                "festive",
                "summer",
            ],
            users: [150, null],
        },
        {
            url: "https://preset-world-21696.map-storage.workadventu.re/startup.wam",
            image: "/images/maps/startup.png",
            name: "Startup",
            tags: [
                "virtual_office",
                "workshops",
                "job_fairs",
                "trade_fairs",
                "employees_onboardings",
                "networking_team_building",
                "other_event",
                "work",
                "chill",
                "collaborate",
                "event",
                "winter",
            ],
            users: [10, 30],
        },
        /*{
            url: "https://workadventure.github.io/huge-open-space/map.json",
            image: "/images/maps/huge-open-space.png",
            name: "Huge Open Space",
            tags: [
                "virtual_office",
                "employees_onboardings",
                "networking_team_building",
                "other_event",
                "work",
                "collaborate",
                "event",
                "urban",
            ],
            users: [70, 150],
        },*/
        /*{
            url: "https://workadventure.github.io/underwater-office/map.json",
            image: "/images/maps/underwater-office.png",
            name: "Underwater Office",
            tags: [
                "virtual_office",
                "webinars",
                "workshops",
                "hackathon",
                "employees_onboardings",
                "networking_team_building",
                "social_meetups",
                "other_event",
                "work",
                "collaborate",
                "event",
                "urban",
                "medieval",
                "futuristic",
                "winter",
            ],
            users: [50, 100],
        },*/
        {
            url: "https://preset-world-21696.map-storage.workadventu.re/nature-office-wam/map.wam",
            image: "https://preset-world-21696.map-storage.workadventu.re/nature-office-wam/map.png",
            name: "Nature Office",
            tags: [
                "virtual_office",
                "employees_onboardings",
                "networking_team_building",
                "other_event",
                "work",
                "chill",
                "collaborate",
                "event",
                "urban",
                "festive",
                "summer",
            ],
            users: [10, 30],
        },
        /*{
            url: "https://workadventure.github.io/space-station-office/map.json",
            image: "/images/maps/space-station-office.png",
            name: "Space Station Office",
            tags: [
                "virtual_office",
                "employees_onboardings",
                "networking_team_building",
                "social_meetups",
                "other_event",
                "work",
                "chill",
                "collaborate",
                "event",
                "futuristic",
            ],
            users: [20, 100],
        },*/
        /*{
            url: "https://workadventure.github.io/open-spaces/map.json",
            image: "/images/maps/open-spaces.png",
            name: "Open Spaces",
            tags: [
                "virtual_office",
                "employees_onboardings",
                "networking_team_building",
                "other_event",
                "work",
                "chill",
                "collaborate",
                "event",
                "urban",
                "festive",
                "summer",
            ],
            users: [50, 100],
        },*/
        /*{
            url: "https://workadventure.github.io/agency/map.json",
            image: "/images/maps/agency.png",
            name: "Agency",
            tags: [
                "virtual_office",
                "workshops",
                "hackathon",
                "employees_onboardings",
                "other_event",
                "work",
                "chill",
                "collaborate",
                "event",
                "urban",
                "festive",
                "summer",
            ],
            users: [20, 50],
        },*/
        /*{
            url: "https://workadventure.github.io/workspace/map.json",
            image: "/images/maps/workspace.png",
            name: "Workspace",
            tags: [
                "virtual_office",
                "workshops",
                "hackathon",
                "social_meetups",
                "other_event",
                "work",
                "chill",
                "collaborate",
                "event",
                "urban",
                "festive",
                "summer",
            ],
            users: [20, 60],
        },*/
    ],
    eventMaps: [
        {
            url: "https://workadventure.github.io/wam-preset-workshop/map.wam",
            image: "/images/maps/workshop.png",
            name: "Workshop",
            tags: [
                "workshops",
                "hackathon",
                "job_fairs",
                "trade_fairs",
                "networking_team_building",
                "social_meetups",
                "other_event",
                "collaborate",
                "event",
                "presentation",
                "urban",
            ],
            users: [100, 200],
        },
        {
            url: "https://workadventure.github.io/wam-preset-webinar/map.wam",
            image: "/images/maps/webinar.png",
            name: "Webinar",
            tags: [
                "workshops",
                "hackathon",
                "job_fairs",
                "trade_fairs",
                "networking_team_building",
                "social_meetups",
                "other_event",
                "collaborate",
                "chill",
                "event",
                "presentation",
                "urban",
                "festive",
                "summer",
            ],
            users: [150, 300],
        },
        {
            url: "https://workadventure.github.io/wam-preset-team-building/map.wam",
            image: "/images/maps/team-building.png",
            name: "Team Building",
            tags: [
                "webinars",
                "workshops",
                "employees_onboardings",
                "networking_team_building",
                "social_meetups",
                "other_event",
                "chill",
                "collaborate",
                "event",
                "presentation",
                "urban",
                "festive",
            ],
            users: [20, 50],
        },
        {
            url: "https://preset-world-21696.map-storage.workadventu.re/preset-hackathon/map.wam",
            image: "https://preset-world-21696.map-storage.workadventu.re/preset-hackathon/map.png",
            name: "Hackathon",
            tags: [
                "workshops",
                "hackathon",
                "job_fairs",
                "trade_fairs",
                "networking_team_building",
                "other_event",
                "chill",
                "collaborate",
                "event",
                "presentation",
                "urban",
                "festive",
                "summer",
            ],
            users: [150, 300],
        },
        /*{
            url: "https://workadventure.github.io/networking/map.json",
            image: "/images/maps/networking.png",
            name: "Networking",
            tags: [
                "workshops",
                "hackathon",
                "job_fairs",
                "trade_fairs",
                "networking_team_building",
                "other_event",
                "chill",
                "collaborate",
                "event",
                "presentation",
                "medieval",
                "festive",
                "summer",
            ],
            users: [150, 300],
        },*/
        {
            url: "https://workadventure.github.io/wam-preset-small-workshop/map.wam",
            image: "/images/maps/small-workshop.png",
            name: "Small Workshop",
            tags: [
                "workshops",
                "hackathon",
                "job_fairs",
                "trade_fairs",
                "networking_team_building",
                "other_event",
                "work",
                "collaborate",
                "event",
                "presentation",
                "urban",
            ],
            users: [150, 300],
        },
        {
            url: "https://workadventure.github.io/wam-preset-sponsorship/map.wam",
            image: "/images/maps/sponsorship.png",
            name: "Sponsorship",
            tags: [
                "workshops",
                "hackathon",
                "job_fairs",
                "trade_fairs",
                "employees_onboardings",
                "networking_team_building",
                "social_meetups",
                "other_event",
                "collaborate",
                "event",
                "presentation",
                "urban",
                "summer",
            ],
            users: [250, null],
        },
        /*{
            url: "https://workadventure.github.io/speed-networking/map.json",
            image: "/images/maps/speed-networking.png",
            name: "Speed Networking",
            tags: [
                "webinars",
                "workshops",
                "hackathon",
                "job_fairs",
                "trade_fairs",
                "employees_onboardings",
                "networking_team_building",
                "social_meetups",
                "other_event",
                "work",
                "collaborate",
                "event",
                "presentation",
                "urban",
                "festive",
                "summer",
            ],
            users: [10, 30],
        },*/
    ],
    chillMaps: [
        /*{
            url: "https://workadventure.github.io/chillin-at-the-beach/map.json",
            image: "/images/maps/chillin-at-the-beach.png",
            name: "Chillin' at the Beach",
            tags: [
                "workshops",
                "hackathon",
                "job_fairs",
                "trade_fairs",
                "employees_onboardings",
                "networking_team_building",
                "social_meetups",
                "other_event",
                "chill",
                "collaborate",
                "event",
                "medieval",
                "festive",
                "summer",
            ],
            users: [150, 500],
        },*/
        /*{
            url: "https://workadventure.github.io/space-station-among-us/map.json",
            image: "/images/maps/space-station-among-us.png",
            name: "Space Station Among Us",
            tags: [
                "workshops",
                "hackathon",
                "job_fairs",
                "trade_fairs",
                "employees_onboardings",
                "networking_team_building",
                "social_meetups",
                "other_event",
                "work",
                "chill",
                "collaborate",
                "event",
                "futuristic",
                "festive",
            ],
            users: [100, 300],
        },*/
        /*{
            url: "https://workadventure.github.io/island/map.json",
            image: "/images/maps/island.png",
            name: "Island",
            tags: [
                "webinars",
                ,
                "employees_onboardings",
                "networking_team_building",
                "social_meetups",
                "other_event",
                "chill",
                "collaborate",
                "event",
                "medieval",
                "summer",
            ],
            users: [50, 200],
        },*/
        /*{
            url: "https://workadventure.github.io/speakeasy/map.json",
            image: "/images/maps/speakeasy.png",
            name: "Speakeasy",
            tags: [
                "webinars",
                "employees_onboardings",
                "networking_team_building",
                "social_meetups",
                "other_event",
                "chill",
                "collaborate",
                "event",
                "urban",
                "festive",
            ],
            users: [10, 30],
        },*/
        /*{
            url: "https://workadventure.github.io/game-room/map.json",
            image: "/images/maps/game-room.png",
            name: "Game Room",
            tags: [
                "webinars",
                "employees_onboardings",
                "networking_team_building",
                "social_meetups",
                "other_event",
                "chill",
                "collaborate",
                "event",
                "urban",
                "festive",
                "winter",
            ],
            users: [10, 50],
        },*/
        /*{
            url: "https://workadventure.github.io/merry-christmas/map.json",
            image: "/images/maps/merry-christmas.png",
            name: "Merry Christmas",
            tags: [
                "webinars",
                "employees_onboardings",
                "networking_team_building",
                "social_meetups",
                "other_event",
                "chill",
                "collaborate",
                "event",
                "urban",
                "festive",
                "winter",
            ],
            users: [10, 50],
        },*/
        /*{
            url: "https://workadventure.github.io/we-love-france/map.json",
            image: "/images/maps/we-love-france.png",
            name: "We Love France",
            tags: [
                "webinars",
                "employees_onboardings",
                "networking_team_building",
                "social_meetups",
                "other_event",
                "chill",
                "collaborate",
                "event",
                "medieval",
                "summer",
            ],
            users: [10, 50],
        },*/
    ],
    eLearningMaps: [
        {
            url: "https://workadventure.github.io/wam-preset-university/map.wam",
            image: "/images/maps/university.png",
            name: "University",
            tags: [
                "workshops",
                "hackathon",
                "job_fairs",
                "trade_fairs",
                "employees_onboardings",
                "networking_team_building",
                "social_meetups",
                "other_event",
                "work",
                "learn",
                "collaborate",
                "event",
                "presentation",
                "urban",
                "festive",
                "summer",
            ],
            users: [50, 100],
        },
        /*{
            url: "https://workadventure.github.io/classroom/map.json",
            image: "/images/maps/classroom.png",
            name: "Classroom",
            tags: [
                "webinars",
                "workshops",
                "hackathon",
                "employees_onboardings",
                "networking_team_building",
                "other_event",
                "work",
                "learn",
                "collaborate",
                "event",
                "presentation",
                "urban",
            ],
            users: [20, 40],
        },*/
        {
            /*url: "https://workadventure.github.io/school/map.json",*/
            /** Use wam file genrated from the world preset map "World Presset" */
            url: "https://preset-world-21696.map-storage.workadventu.re/school.wam",
            image: "/images/maps/school.png",
            name: "School",
            tags: [
                "webinars",
                "workshops",
                "hackathon",
                "employees_onboardings",
                "networking_team_building",
                "other_event",
                "work",
                "learn",
                "chill",
                "collaborate",
                "event",
                "presentation",
                "urban",
                "summer",
            ],
            users: [20, 60],
        },
    ],
    eCommerceMaps: [],
};
export const partnersMaps = [
    {
        url: "https://preset-world-21696.map-storage.workadventu.re/hackathon/Hackathon.wam",
        image: "https://preset-world-21696.map-storage.workadventu.re/hackathon/Hackathon.png",
        name: "Modern Hackathon",
        tags: [
            "workshops",
            "hackathon",
            "job_fairs",
            "trade_fairs",
            "other_event",
            "work",
            "chill",
            "collaborate",
            "event",
            "festive",
            "summer",
            "seminar",
            "conference"
        ],
        users: [300, null],
        editor: "Komponent Works"
    },
    {
        url: "https://preset-world-21696.map-storage.workadventu.re/smalloffice/smallOffice.wam",
        image: "https://preset-world-21696.map-storage.workadventu.re/smalloffice/smallOffice.png",
        name: "Small Office",
        tags: [
            "partners",
            "workshops",
            "hackathon",
            "job_fairs",
            "trade_fairs",
            "other_event",
            "work",
            "chill",
            "collaborate",
            "event",
            "festive",
            "summer",
        ],
        users: [10, 100],
        editor: "Komponent Works"
    },
    {
        url: "https://preset-world-21696.map-storage.workadventu.re/scifi/smallOffice_scifi.wam",
        image: "https://preset-world-21696.map-storage.workadventu.re/scifi/smallOffice_scifi.png",
        name: "Sci-Fi Small Office",
        tags: [
            "partners",
            "workshops",
            "hackathon",
            "job_fairs",
            "trade_fairs",
            "other_event",
            "work",
            "chill",
            "collaborate",
            "event",
            "festive",
            "summer",
        ],
        users: [10, 100],
        editor: "Komponent Works"
    },
    {
        url: "https://preset-world-21696.map-storage.workadventu.re/nature/smallOffice_nature.wam",
        image: "https://preset-world-21696.map-storage.workadventu.re/nature/smallOffice_nature.png",
        name: "Nature Small Office",
        tags: [
            "partners",
            "workshops",
            "hackathon",
            "job_fairs",
            "trade_fairs",
            "other_event",
            "work",
            "chill",
            "collaborate",
            "event",
            "festive",
            "summer",
        ],
        users: [10, 50],
        editor: "Komponent Works"
    },
    {
        url: "https://preset-world-21696.map-storage.workadventu.re/medieval/smallOffice_medieval.wam",
        image: "https://preset-world-21696.map-storage.workadventu.re/medieval/smallOffice_medieval.png",
        name: "Medieval Small Office",
        tags: [
            "partners",
            "workshops",
            "hackathon",
            "job_fairs",
            "trade_fairs",
            "other_event",
            "work",
            "chill",
            "collaborate",
            "event",
            "festive",
            "summer",
        ],
        users: [10, 100],
        editor: "Komponent Works",
    },
    {
        url: "https://preset-world-21696.map-storage.workadventu.re/conference-campus.wam",
        image: "/images/maps/conference-campus.png",
        name: "Conference Campus",
        tags: [
            "partners",
            "workshops",
            "hackathon",
            "job_fairs",
            "trade_fairs",
            "other_event",
            "work",
            "chill",
            "collaborate",
            "event",
            "festive",
            "summer",
        ],
        users: [10, 100],
        editor: "DigiPie Design",
    },
    {
        url: "https://preset-world-21696.map-storage.workadventu.re/workhub/workhub.wam",
        image: "/images/maps/workhub.png",
        name: "Workhub",
        tags: [
            "partners",
            "workshops",
            "hackathon",
            "job_fairs",
            "trade_fairs",
            "other_event",
            "work",
            "chill",
            "collaborate",
            "event",
            "festive",
            "summer",
        ],
        users: [50, 100],
        editor: "Komponent Works",
    },
    {
        url: "https://preset-world-21696.map-storage.workadventu.re/gallery-sphere.wam",
        image: "/images/maps/gallery-sphere.png",
        name: "Gallery sphere",
        tags: [
            "partners",
            "workshops",
            "hackathon",
            "job_fairs",
            "trade_fairs",
            "other_event",
            "work",
            "chill",
            "collaborate",
            "event",
            "festive",
            "summer",
        ],
        users: [10, 100],
        editor: "K20 Educators",
    },
    {
        url: "https://preset-world-21696.map-storage.workadventu.re/lounge.wam",
        image: "/images/maps/lounge.png",
        name: "Lounge",
        tags: [
            "partners",
            "workshops",
            "hackathon",
            "job_fairs",
            "trade_fairs",
            "other_event",
            "work",
            "chill",
            "collaborate",
            "event",
            "festive",
            "summer",
        ],
        users: [10, 100],
        editor: "K20 Educators",
    },
    {
        url: "https://preset-world-21696.map-storage.workadventu.re/kw/sailboat.wam",
        image: "https://preset-world-21696.map-storage.workadventu.re/kw/sailboat.png",
        name: "Sailboat",
        tags: [
            "partners",
            "workshops",
            "hackathon",
            "job_fairs",
            "trade_fairs",
            "other_event",
            "work",
            "chill",
            "collaborate",
            "event",
            "festive",
            "summer",
        ],
        users: [10, 100],
        editor: "Komponent Works",
    },
];
export const urlListByKey = Object.keys(maps).reduce((object, key) => {
    if (!object[key]) {
        object[key] = [];
    }
    object[key] = object[key].concat(
        maps[key].reduce((urls, object) => {
            urls.push(object.url);
            return urls;
        }, [])
    );
    return object;
}, {});
Vue.component("list-map", {
    props: {
        tabFocus: String,
    },
    mounted() {
        $("#" + this.tabFocus).tab("show");
    },
    computed: {
        mapUrlList() {
            return urlListByKey;
        },
    },
});
